export default s => `{${s}}`
